module.exports = __webpack_public_path__ + "static/img/logo2.b556f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = xAza
// module chunks = 81